import z from "zod"

export const DateFilterOperator = {
  IS_EMPTY: "isEmpty",
  IS_NOT_EMPTY: "isNotEmpty",
  BETWEEN: "between",
  EQUALS: "equals",
  BEFORE: "before",
  AFTER: "after",
  NOT_EQUALS: "notEquals",
  IS_BEFORE_OR_EQUALS: "isBeforeOrEquals",
  IS_AFTER_OR_EQUALS: "isAfterOrEquals",
  IS_NOT_BETWEEN: "isNotBetween",
} as const

export type DateFilterOperator =
  (typeof DateFilterOperator)[keyof typeof DateFilterOperator]

export const SlidingPreset = {
  TODAY: "today",
  TOMORROW: "tomorrow",
  YESTERDAY: "yesterday",
  ONE_WEEK_AGO: "oneWeekAgo",
  ONE_WEEK_FROM_NOW: "oneWeekFromNow",
  ONE_MONTH_AGO: "oneMonthAgo",
  ONE_MONTH_FROM_NOW: "oneMonthFromNow",
  ONE_YEAR_AGO: "oneYearAgo",
  ONE_YEAR_FROM_NOW: "oneYearFromNow",
  CUSTOM: "custom",
} as const

export type SlidingPreset = (typeof SlidingPreset)[keyof typeof SlidingPreset]

export const DateFilterType = {
  SLIDER: "slider",
  FIXED: "fixed",
} as const

export type DateFilterType =
  (typeof DateFilterType)[keyof typeof DateFilterType]

export type DateRangeDto = {
  startDate: Date | undefined
  endDate: Date | undefined
}

const rangeSchema = z.object({
  startDate: z.date().optional(),
  endDate: z.date().optional(),
})

export const dateFilterDtoSchema = z
  .object({
    operator: z.enum(DateFilterOperator),
    type: z.enum(DateFilterType),
    preset: z.enum(SlidingPreset),
    range: rangeSchema.optional(),
  })
  .refine(
    (data) => {
      if (data.preset === SlidingPreset.CUSTOM) {
        return (
          data.type === DateFilterType.FIXED &&
          rangeSchema.safeParse(data.range).success
        )
      }

      return true
    },
    {
      message: "Range is required for fixed type",
      path: ["preset"],
    }
  )

export type DateFilterDto = z.infer<typeof dateFilterDtoSchema>
